import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ShowerHeadPage = lazy(() => import('../pages/showerhead/page'));
const GeneratorPage = lazy(() => import('../pages/generator/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/showerhead',
    element: <ShowerHeadPage />,
  },
  {
    path: '/generator',
    element: <GeneratorPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;